<template>
  <div class="m-event pc" @click="hideBox">
    <Header
      @routerEvent="layoutEvent"
      @logout="logout"
      v-if="extras && seminarInfo"
      :loginUrl="loginUrl"
      :registerUrl="registerUrl"
      :extras="extras"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
    />
    <Banner
      v-if="extras && seminarInfo"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
      :isFrozen="isFrozen"
      :signUpStatus="signUpStatus"
      :loginUrl="loginUrl"
      :registerUrl="registerUrl"
      :extras="extras"
    />
    <Suspension
      ref="suspension"
      v-if="extras && memberInfo && seminarInfo"
      :extras="extras"
      :isFrozen="isFrozen"
      :signUpStatus="signUpStatus"
      :seminarInfo="seminarInfo"
      :markCode="markCode"
      :memberInfo="memberInfo"
    />
    <Introduction
      v-if="extras && seminarInfo"
      :seminarInfo="seminarInfo"
      :extras="extras"
    />
    <GuestInfo
      v-if="extras && seminarInfo"
      :guests="seminarInfo.guests"
      :extras="extras"
    />
    <Schedule
      v-if="extras && seminarInfo"
      :extras="extras"
      :agendas="seminarInfo.agendas"
    />
    <NewInfo v-if="extras && newsInfo" :newsInfo="newsInfo" :extras="extras" />
    <Partner
      v-if="extras && partnerInfo"
      :partnerInfo="partnerInfo"
      :extras="extras"
    />
    <DownloadInfo
      v-if="extras && fileInfo"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
      :fileInfo="fileInfo"
      :extras="extras"
    />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/pc/Header.vue";
import Banner from "@/components/pc/Banner.vue";
import Introduction from "@/components/pc/Introduction.vue";
import Schedule from "@/components/pc/Schedule.vue";
import GuestInfo from "@/components/pc/GuestInfo.vue";
import NewInfo from "@/components/pc/NewInfo.vue";
import Partner from "@/components/pc/Partner.vue";
import DownloadInfo from "@/components/pc/DownloadInfo.vue";
import Suspension from "@/components/pc/Suspension.vue";
import Footer from "../../components/pc/Footer";
import Api from "../../service/api";
import { URLS } from "fire-wind-water";
import seminarMixin from "../../mixins/seminar";

export default {
  name: "Index",
  data() {
    return {
      fileInfo: null,
      newsInfo: null,
      partnerInfo: null,
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
    };
  },
  components: {
    Header,
    Banner,
    Introduction,
    Schedule,
    GuestInfo,
    NewInfo,
    DownloadInfo,
    Partner,
    Suspension,
    Footer,
  },
  mixins: [seminarMixin],
  created() {
    window.$sk.loading.show();
    this.initPage();
  },
  computed: {
    loginUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.login);
      } else {
        return "";
      }
    },
    registerUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.register);
      } else {
        return "";
      }
    },
  },
  methods: {
    async initPage() {
      const instanceId = URLS.getURL("instanceId");
      let info = window.$sk.template.get();
      const { globalUserId } = info.user;
      await Api.getArticleList({
        instanceId,
        globalUserId,
        sort: [6, 8],
        type: "news", //新闻资讯
      }).subscribe((newsInfoRes) => {
        this.newsInfo = newsInfoRes.content;
      });

      await Api.getArticleList({
        instanceId,
        globalUserId,
        sort: [6, 8],
        type: "partner", //合作伙伴
      }).subscribe((partnerInfoRes) => {
        this.partnerInfo = partnerInfoRes.content;
      });

      await Api.getFileList({
        instanceId,
        globalUserId,
      }).subscribe((FileRes) => {
        this.fileInfo = FileRes.content;
      });
      // window.$sk.loading.hide();
    },
    logout() {
      const info = window.$sk.template.get();
      info.cookie.removeSession();
      this.$refs.suspension.clearSession();
      this.memberInfo = {
        name: "",
        headImg: "",
        email: "",
        signUpStatus: 0,
      };
    },
    handleBackUrl: function (url) {
      if (!url) {
        return "";
      } else {
        let _url = "";
        const hasBackUrl = url.indexOf("backUrl");
        if (hasBackUrl !== -1) {
          _url =
            url.slice(0, hasBackUrl - 1) +
            "&backUrl=" +
            encodeURIComponent(location.href);
        } else {
          _url = url + "&backUrl=" + encodeURIComponent(location.href);
        }
        return _url;
      }
    },
    downloadEvent(mailbox, fileList) {
      const instanceId = URLS.getURL("instanceId");
      const { globalUserId } = this.template.user;
      Api.getDownloadWithEmail({
        instanceId,
        email: mailbox,
        globalUserId,
        moduleType: 3,
        fileList: fileList,
      }).subscribe(() => {});
    },
    layoutEvent(item) {
      let items = document.querySelectorAll(".top-nav");
      for (let i = 0; i < items.length; i++) {
        const stel = document.getElementById(item.key);
        if (stel) {
          stel.scrollIntoView({
            block: "center", //默认跳转到顶部
            behavior: "smooth", //滚动的速度
          });
        }
      }
    },
    hideBox(e) {
      let isBox = false;
      if (e && e.path) {
        e.path.forEach((path) => {
          if (path.className) {
            let className = path.className.toString();
            if (className.indexOf("m-qrcode") >= 0) {
              isBox = true;
            }
          }
        });
        if (!isBox) {
          this.$refs.suspension.closeBox();
        }
      }
    },
  },
};
</script>
